export { draggable, dropTargetForElements, monitorForElements } from '../../adapter/element-adapter';

// Payload for the draggable being dragged